import styled from 'styled-components';
import React from 'react';
import { Flex } from '../base/layout-components';
import { getColor } from 'common/constants/_colors';

const TooltipTitle = styled(Flex)`
  background: ${getColor('catskillGray')};
  padding: 1rem;
`;
const Wrapper = styled(Flex)`
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(84, 103, 255, 0.2);
  box-shadow: 0 0 30px rgba(59, 89, 152, 0.15);
  border-radius: 5px;
`;

const TooltipWrapper = ({ title, children, ...rest }) => (
  <Wrapper direction='column' {...rest}>
    {title && <TooltipTitle items='center'>{title}</TooltipTitle>}
    {children}
  </Wrapper>
);
export const ScaledTooltipWrapper = styled(TooltipWrapper)`
  ${({ scale }) => `transform: scale(${scale});`}
`;
export default TooltipWrapper;
